import userflow from 'userflow.js';
import { useEffect, useRef } from 'react';
import { useAuth } from 'src/state/auth';
import { useStateSelector } from 'src/redux';

const USERFLOW_TOKEN = process.env.USERFLOW_TOKEN || 'null';
const isEnabled = USERFLOW_TOKEN !== 'null';

export const useUserflow = () => {
  const { profile, flatOrganisations, appLoaded } = useAuth();
  const scheme = useStateSelector(({ theme }) => theme.scheme);
  const isInitializedRef = useRef(false);
  const identifiedUserIdRef = useRef<string | null>(null);
  const lastSchemeRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isEnabled || !appLoaded || !profile?.user) return;

    if (!isInitializedRef.current) {
      userflow.init(USERFLOW_TOKEN);
      isInitializedRef.current = true;
    }

    const userId = profile.user.id;
    const userFlowSignature = profile.userFlowSignature;
    const activeOrgId = profile.activeOrganisation?.id;
    const org = flatOrganisations.find((o) => o.id === activeOrgId);
    const darkMode = scheme === 'dark';

    const needsUpdate = identifiedUserIdRef.current !== userId || lastSchemeRef.current !== scheme;
    if (!needsUpdate) return;

    const attributes = {
      name: profile.user.name,
      email: profile.user.email,
      role: profile.user.orgUnitIdentity?.baseRole,
      dark_mode: darkMode,
      org_name: org?.name,
      org_type: org?.organisationType,
      business_type: org?.businessType,
    };

    userflow.identify(userId, attributes, {
      signature: userFlowSignature,
    });

    identifiedUserIdRef.current = userId;
    lastSchemeRef.current = scheme;
  }, [appLoaded, profile, flatOrganisations, scheme]);
};
